import React from 'react';
import { Box } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { user } from '€slices/user';
import UserDetailsTable from './UserDetailsTable';

const UserDetails: React.FunctionComponent = () => {
    const $user = useSelector(user);
    return (
        <Box display="flex" flexDirection="column" width="100%" data-testid="quote-summary">
            <UserDetailsTable
                title={{
                    xs: 'Personal information',
                    sm: 'Your personal details',
                }}
                subTitle="Your details"
                description="Make sure we have your latest details. This helps us give you the most accurate information based on your money needs."
                rows={[
                    { label: 'name', value: $user.name },
                    { label: 'email', value: $user.email },
                ]}
            />
        </Box>
    );
};

export default UserDetails;
